import styled, { keyframes } from 'styled-components'

export const fade = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`

export const FadeIn = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: #ffd070;
  animation: ${fade} 4s normal forwards ease-in-out;
`

export const Container = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  & h1 {
    padding: 0;
    margin: 0 0 0.05em 0;
    font-family: 'Abril Fatface', serif;
    font-weight: 400;
    font-size: min(10.8vw, 8.4em);
    line-height: 0.85em;
  }
`

export const TopLeft = styled.div`
  position: absolute;
  top: 5vw;
  left: 5vw;
`

export const BottomLeft = styled.div`
  position: absolute;
  bottom: 5vw;
  left: 5vw;
  width: 30ch;
  max-width: 40%;
`

export const BottomRight = styled.div`
  position: absolute;
  bottom: 5vw;
  right: 5vw;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
`

export const Button = styled.a`
  background: transparent;
  border: none;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 32px;
  font-weight: 500;
  color: #252525;
  text-decoration: none;
  letter-spacing: -0.02em;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;

  &:hover {
    color: #000;
    letter-spacing: 0.02em;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: #252525;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`

export const Hamburger = styled.div`
  position: absolute;
  display: ${props => props.isOpen ? 'none' : 'flex'};
  flex-direction: column;
  top: 5vw;
  right: 5vw;
  cursor: pointer;
  z-index: 1001;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.7;
  }

  & > div {
    position: relative;
    width: 24px;
    height: 2px;
    background: #252525;
    margin-bottom: 6px;
    transition: all 0.3s ease;
  }
`

export const LeftMiddle = styled.div`
  position: absolute;
  bottom: 50%;
  right: 5vw;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  line-height: 1em;
  letter-spacing: -0.01em;
  font-size: 12px;
  transform: rotate(90deg) translate3d(50%, 0, 0);
  transform-origin: 100% 50%;
`

export const Center = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  max-width: 600px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  @media (max-width: 768px) {
    width: 70%;
    max-width: 500px;
  }

  @media (max-width: 480px) {
    width: 95%;
    max-width: 550px;
  }
`

export const NavBar = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.isOpen ? '0' : '-100%'};
  width: 100%;
  height: 100vh;
  background: rgba(37, 37, 37, 0.98);
  backdrop-filter: blur(10px);
  z-index: 1000;
  transition: right 0.25s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 769px) {
    width: 450px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 5vw;
  right: 5vw;
  background: transparent;
  border: none;
  color: #ffd070;
  font-size: 48px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: rotate(90deg);
    opacity: 0.7;
  }
`

export const NavMenu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;

  li {
    margin: 0;
    padding: 0;
  }

  a {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #ffd070;
    text-decoration: none;
    letter-spacing: -0.02em;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      color: #fff;
      letter-spacing: 0.05em;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 0;
      height: 2px;
      background: #ffd070;
      transition: width 0.3s ease;
    }

    &:hover::after {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    gap: 24px;

    a {
      font-size: 24px;
    }
  }
`

export const WaitlistContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(37, 37, 37, 0.95);
  backdrop-filter: blur(10px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`

export const WaitlistContent = styled.div`
  background: #ffd070;
  padding: 60px 50px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  position: relative;
  animation: slideUp 0.4s ease;

  @keyframes slideUp {
    from {
      transform: translateY(30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 480px) {
    padding: 40px 30px;
  }
`

export const CloseWaitlist = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: #252525;
  font-size: 40px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: rotate(90deg);
    opacity: 0.7;
  }
`

export const WaitlistTitle = styled.h2`
  font-family: 'Abril Fatface', serif;
  font-size: 42px;
  font-weight: 400;
  color: #252525;
  margin: 0 0 16px 0;
  line-height: 1.1;

  @media (max-width: 480px) {
    font-size: 32px;
  }
`

export const WaitlistSubtitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  color: #252525;
  margin: 0 0 40px 0;
  opacity: 0.8;

  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 30px;
  }
`

export const WaitlistForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const WaitlistInput = styled.input`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  padding: 16px 20px;
  border: 2px solid #252525;
  background: transparent;
  color: #252525;
  border-radius: 8px;
  transition: all 0.3s ease;
  outline: none;

  &::placeholder {
    color: rgba(37, 37, 37, 0.5);
  }

  &:focus {
    border-color: #000;
    background: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    padding: 14px 18px;
  }
`

export const WaitlistButton = styled.button`
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 600;
  padding: 18px 32px;
  background: #252525;
  color: #ffd070;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;

  &:hover:not(:disabled) {
    background: #000;
    transform: translateY(-2px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    padding: 16px 28px;
  }
`

export const WaitlistMessage = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #252525;
  margin: 20px 0 0 0;
  text-align: center;
  padding: 12px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  animation: fadeIn 0.3s ease;
`
